import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import toString from 'lodash/toString';
import { pageFilters } from '../../modules/new-search-page/searchPageFilters';
import callApi, { newcallApi } from '../../util/apiCaller';

import { userNotify } from '../../modules/components/Toasts/ToastAdd';
import { setPageNotFound, setPageRedirect } from './AppActions';
import { sortTheList } from '../../util/utility';
import { callSearchAPI } from '../../util/vmSearch';
import venueCallApi, { uploadFile, venueCallApiFormData } from '../../util/apiVenueCaller';
// import callManagerApi from '../../util/managerApiCaller';
export const TOGGLE_NEW_EVENT_PLAN_MODAL = 'TOGGLE_NEW_EVENT_PLAN_MODAL';
//SearchPage Header
export const SET_SUBAREAS = 'SET_SUBAREAS'; // copy
export const SET_FILTERS = 'SET_FILTERS'; // copy
export const SET_PAGE_FILTERS = 'SET_PAGE_FILTERS'; // copy
export const SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS'; //copy
export const SET_PAGETAGS = 'SET_PAGETAGS';
export const FETCHING_VENUES = 'FETCHING_VENUES';
export const GET_VENUES = 'GET_VENUES';
export const FETCH_REVIEWS_FOR_PAGE = 'FETCH_REVIEWS_FOR_PAGE';
export const FETCH_REVIEW_SUCCESS = 'FETCH_REVIEW_SUCCESS';

//SearchPage Filters
export const SET_VENUE_FILTER = 'SET_VENUE_FILTER';
export const SET_VENUE_FILTER_ITEM = 'SET_VENUE_FILTER_ITEM';
export const SET_MIN_MAX_VENUE_FILTER_ITEM = 'SET_MIN_MAX_VENUE_FILTER_ITEM';
export const RESET_FILTERS = 'RESET_FILTERS'; //copy
export const FETCHING_SEARCH_LIST = 'FETCHING_SEARCH_LIST';
export const FETCH_SEARCH_LIST = 'FETCH_SEARCH_LIST';
export const SET_VENUES = 'SET_VENUES';
export const SET_CITY = 'SET_CITY';
export const SET_SORT_FILTERS = 'SET_SORT_FILTERS';
export const SHORTLISTING_VENUE_FROM_LIST = 'SHORTLISTING_VENUE_FROM_LIST';
export const EVENT_MADE_STATE = 'EVENT_MADE_STATE';
export const SET_SELECTED_VENUE = 'SET_SELECTED_VENUE';
export const UPDATING_VENUE_SEARCH_VALIDATORS = 'UPDATING_VENUE_SEARCH_VALIDATORS';
export const UPDATE_VENUE_SEARCH_VALIDATORS = 'UPDATE_VENUE_SEARCH_VALIDATORS';

//Venue Page
export const SET_REVIEW_MODAL_STATE = 'SET_REVIEW_MODAL_STATE';
export const SET_REVIEW_SUCCESS_MODAL_STATE = 'SET_REVIEW_SUCCESS_MODAL_STATE';
export const SET_REVIEW_LIST_MODAL_STATE = 'SET_REVIEW_LIST_MODAL_STATE';
export const GET_SIMILAR_VENUES = 'GET_SIMILAR_VENUES';
export const FETCH_VENUE_PAGE = 'FETCH_VENUE_PAGE';
export const FETCH_ASSET_PAGE = 'FETCH_ASSET_PAGE';
export const FETCH_REVIEW_PAGE = 'FETCH_REVIEW_PAGE';
export const FETCH_PACKAGE_PAGE = 'FETCH_PACKAGE_PAGE';
export const FETCHING_VENUE = 'FETCHING_VENUE';
export const FETCH_VENUE = 'FETCH_VENUE';
export const FETCH_REVIEW = 'FETCH_REVIEW';
export const FETCHING_REVIEW = 'FETCHING_REVIEW';
export const FETCHING_VENUE_COMMENTS = 'FETCHING_VENUE_COMMENTS';
export const FETCH_VENUE_COMMENTS = 'FETCH_VENUE_COMMENTS';
export const TOGGLE_NEW_COMMENT = 'TOGGLE_NEW_COMMENT';
export const FETCH_USER_COMMENT = 'FETCH_USER_COMMENT';
export const EDIT_USER_COMMENT = 'EDIT_USER_COMMENT';
export const UPDATING_USER_COMMENT = 'UPDATING_USER_COMMENT';
export const DELETING_USER_COMMENT = 'DELETING_USER_COMMENT';
export const SHORTLISTING_VENUE_FOR_EVENT = 'SHORTLISTING_VENUE_FOR_EVENT';
export const FETCHING_SIMILAR_VENUES = 'FETCHING_SIMILAR_VENUES';
export const FETCH_SIMILAR_VENUES = 'FETCH_SIMILAR_VENUES';
export const SET_QNA_PAGE_NUM = 'SET_QNA_PAGE_NUM';
export const FETCH_POPULAR_VENUES = 'FETCH_POPULAR_VENUES';
export const FETCH_USER_QUESTION = 'FETCH_USER_QUESTION';
export const FETCH_QNA_PAGE = 'FETCH_QNA_PAGE';
export const ADD_ANSWER_MODAL_STATE = 'ADD_ANSWER_MODAL_STATE';
export const LOAD_SUBLINK_PAGE = 'LOAD_SUBLINK_PAGE';
export const GET_QNA_SUGGESTION_LIST = 'GET_QNA_SUGGESTION_LIST';
export const IS_USER_QUESTION_POSTED = 'IS_USER_QUESTION_POSTED';
export const SET_SUCCESS_MODAL_STATE = 'SET_SUCCESS_MODAL_STATE';
export const QUESTION_ALREADY_EXIST = 'QUESTION_ALREADY_EXIST';
export const DELETING_USER_QUESTION = 'DELETING_USER_QUESTION';
export const DELETE_USER_QUESTION = 'DELETE_USER_QUESTION';
export const PROCESSING_DELETE_QUESTION = 'PROCESSING_DELETE_QUESTION';

export const FETCHING_MORE_QNA = 'FETCHING_MORE_QNA';
export const FETCH_MORE_QNA = 'FETCH_MORE_QNA';
export const UPDATE_QNA_HOMEPAGE = 'UPDATE_QNA_HOMEPAGE';

//Review Report
export const FETCHING_REPORTED_COMMENT = 'FETCHING_REPORTED_COMMENT';
export const FETCH_REPORTED_COMMENT = 'FETCH_REPORTED_COMMENT';
export const UPDATING_REPORTED_COMMENT = 'UPDATING_REPORTED_COMMENT';

//Seolink
export const FETCHING_SEOLINKS = 'FETCHING_SEOLINKS';
export const LOAD_SEOLINK = 'LOAD_SEOLINK';

//Searchlink
export const FETCHING_SEARCHLINKS = 'FETCHING_SEARCHLINKS';
export const LOAD_SEARCHLINK = 'LOAD_SEARCHLINK';
export const SET_ACTIVE_LINK_FILTERS = 'SET_ACTIVE_LINK_FILTERS';
export const UPDATE_LODE_MORE_VENUES = 'UPDATE_LODE_MORE_VENUES';

// Reviews Page
export const UPDATING_VENUE_USER_REVIEW = 'UPDATING_VENUE_USER_REVIEW';
export const UPDATE_VENUE_USER_REVIEW = 'UPDATE_VENUE_USER_REVIEW';

export const FETCHING_VENUE_DATA_FOR_COMPARE_PAGE = 'FETCHING_VENUE_DATA_FOR_COMPARE_PAGE';
export const FETCH_VENUE_DATA_FOR_COMPARE_PAGE = 'FETCH_VENUE_DATA_FOR_COMPARE_PAGE';
export const FETCHING_COMPARE_VENUES = 'FETCHING_COMPARE_VENUES';
export const FETCH_COMPARE_VENUES = 'FETCH_COMPARE_VENUES';
export const CLEAR_COMPARE_VENUE_DATA = 'CLEAR_COMPARE_VENUE_DATA';

export const IS_UPLOADING_MEDIA = 'IS_UPLOADING_MEDIA';
export const IS_OPEN_GALLERY_FOR_SEARCHPAGE = 'IS_OPEN_GALLERY_FOR_SEARCHPAGE';
export const CLICKED_VENUE_SEARCH_PAGE = 'CLICKED_VENUE_SEARCH_PAGE';
export const FETCH_VENUE_SEARCH_PAGE_ALL_ASSET = 'FETCH_VENUE_SEARCH_PAGE_ALL_ASSET';
export const SET_VENUE_TOUR_MODAL_VISIBILTIY = 'SET_VENUE_TOUR_MODAL_VISIBILTIY';
export const SET_SAYA_DATE_STATUS = 'SET_SAYA_DATE_STATUS';
export const SAYA_DATE_HIDE_BY_USER = "SAYA_DATE_HIDE_BY_USER";
export const SET_SUCCESS_SCREEN = 'SET_SUCCESS_SCREEN'
export const GET_REVIEW_TICKET_DATA = 'GET_REVIEW_TICKET_DATA'

export function setSortFilters(sortFilters) {
    return {
        type: SET_SORT_FILTERS,
        sortFilters: sortFilters,
    };
}

export function forceHideSayaDateBannee(){
    return{
        type : SAYA_DATE_HIDE_BY_USER,
        isHideSayaDateBanner:true
    }
}

export function updateLodeMoreVenues(data) {
    return {
        type: UPDATE_LODE_MORE_VENUES,
        newVenues: data.venues,
        pageNum: data.pageNum,
        totalCount: data.totalCount,
    };
}

export function setActiveLinkFilters(val) {
    return {
        type: SET_ACTIVE_LINK_FILTERS,
        activeLinkFilters: val,
    };
}


export function setReviewModalState(val) {
    return {
        type: SET_REVIEW_MODAL_STATE,
        isReviewModalVisible: val,
    };
}

export function setReviewSuccessModalState(val) {
    return {
        type: SET_REVIEW_SUCCESS_MODAL_STATE,
        isReviewSuccessModalVisible: val,
    };
}

export function setReviewListModalState(val) {
    return {
        type: SET_REVIEW_LIST_MODAL_STATE,
        isReviewListModalVisible: val,
    };
}

export function fetchingCurrentUserReviewPage(page) {
    return {
        type: FETCH_REVIEWS_FOR_PAGE,
        isLoadingUserReviewsPage: page === 1,
        isFetchingUserReviews: true,
        currentUserReviewPage: page,
    };
}

export function sendReviewsFetchResponse(data) {
    return {
        type: FETCH_REVIEW_SUCCESS,
        isFetchingUserReviews: false,
        isLoadingUserReviewsPage: false,
        userReviews: data.reviews,
        userReviewCount: data.totalCount,
    };
}

export function fetchReviews(userid, page) {
    return (dispatch) => {
        dispatch(fetchingCurrentUserReviewPage(page));
        return callApi(`profile/${userid}/reviews`, 'post', {
            pageNum: page,
            pageSize: 12,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(sendReviewsFetchResponse(res.data));
            } else {
                let data = {
                    reviews: [],
                    totalCount: 0,
                };
                dispatch(sendReviewsFetchResponse(data));
            }
        });
    };
}

export function setVenueFilterItem(paramName, value) {
    return {
        type: SET_VENUE_FILTER_ITEM,
        paramName: paramName,
        value: value,
    };
}

export function setMinMaxVenueFilterItem(paramName, value) {
    return {
        type: SET_MIN_MAX_VENUE_FILTER_ITEM,
        paramName: paramName,
        value: value,
    };
}

export function setVenueFilter(paramName, value, isSelected) {
    return {
        type: SET_VENUE_FILTER,
        paramName: paramName,
        value: value,
        isSelected: isSelected,
    };
}

export function setAppliedFilters(filters) {
    return (dispatch) => {
        dispatch({
            type: SET_APPLIED_FILTERS,
            appliedFilters: filters,
        });
    };
}

export function resetFilters() {
    return {
        type: RESET_FILTERS,
    };
}

export function setVenues(venues) {
    return {
        type: SET_VENUES,
        venues: venues,
    };
}

export function setCity(city) {
    return {
        type: SET_CITY,
        city: city,
    };
}

export function loadSubareas(subareas) {
    return {
        type: SET_SUBAREAS,
        isLocationFiltersLoaded: true,
        locationFilters: subareas,
    };
}

export function fetchBaseFiltersByCity(cityslug, query,defaultFilters) {  //filter Options API Call 
    let url = `search/venues/${toString(cityslug)}/base-filters`;
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        const baseFilter = await callApi(url, 'GET');
        console.log("baseFilter2", baseFilter);
        if (baseFilter?.status === 'Success') {
            dispatch(loadFilters(baseFilter.data, pageFilters));
        } else {
            dispatch(loadFilters({ data: { filters: [], sortsets: [] } },defaultFilters || pageFilters));
        }
    };
}
export function fetchBaseFiltersByCode(baseFilterCode, baseUrl,defaultFilters) {
    return async (dispatch) => {
        const baseFilter = await callApi(`search/${baseFilterCode}/${baseUrl}/base-filters`,`GET`);
        console.log("baseFilter", baseFilter);
        if (baseFilter?.status === 'Success') {
            dispatch(loadFilters(baseFilter.data,defaultFilters ||  pageFilters ));
        } else {
            dispatch(loadFilters({ data: { filters: [], sortsets: [] } },defaultFilters || pageFilters));
        }
    };
}

export function fetchSubAreasByCity(cityslug, query) {
    let url = `search/venues/${toString(cityslug)}/subareas`;
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        const res = await callApi(url, 'GET');
        if (res.status === 'Success') {
            dispatch(loadSubareas(res.data.locations));
        } else {
            dispatch(loadSubareas([]));
        }
    };
}

export function loadFilters(data, searchFilterList) {
    let venueSearchParams = [];
    let venueSearchFilters = [];
    const DYNAMIC_LIST = ['localities', 'regions', 'amenities',"operating_cities"];
    const filteredList = data?.filters?.filter((f) => DYNAMIC_LIST.includes(f.keyName));
    if (filteredList?.length > 0) {
        venueSearchFilters = [...searchFilterList, ...filteredList]
            .map((venueSearch) => {
                if (['capacity', 'price','rooms'].includes(venueSearch.keyName)) {
                    venueSearchParams.push(
                        { paramName: venueSearch.maxParam },
                        { paramName: venueSearch.minParam }
                    );
                } else {
                    venueSearchParams.push({ paramName: venueSearch.queryParamName });
                }
                if (venueSearch.keyName === 'operating_cities') venueSearch.mobileSortOrder = 1;
                if (venueSearch.keyName === 'venuetypes') venueSearch.mobileSortOrder = 2;
                if (venueSearch.keyName === 'rooms') venueSearch.mobileSortOrder = 3;
                if (venueSearch.keyName === 'availability') venueSearch.mobileSortOrder = 4;
                if (venueSearch.keyName === 'localities') venueSearch.mobileSortOrder = 5;
                if (venueSearch.keyName === 'price') venueSearch.mobileSortOrder = 6;
                if (venueSearch.keyName === 'capacity') venueSearch.mobileSortOrder =7;
                if (venueSearch.keyName === 'packagetypes') venueSearch.mobileSortOrder = 8;
                if (venueSearch.keyName === 'occasions') venueSearch.mobileSortOrder = 9;
                if (venueSearch.keyName === 'amenities') venueSearch.mobileSortOrder = 10;
                if (venueSearch?.params?.length > 0) {
                    if (venueSearch?.keyName === 'packagetypes') {
                        venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                    } else {
                        venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                        // venueSearch?.params.sort((a, b) => sortTheList(a, b, 'label', 'asc'));
                    }
                    if (venueSearch?.keyName === 'localities') {
                        venueSearch.displayName = 'Locality';
                    }
                    if (venueSearch?.keyName === 'operating_cities') {
                        venueSearch.displayName = 'Cities';
                    }
                } else if (venueSearch?.maxParams?.length > 0) {
                    venueSearch?.maxParams.sort((a, b) =>
                        sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                    );
                } else if (venueSearch?.minParams?.length > 0) {
                    venueSearch?.minParams.sort((a, b) =>
                        sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                    );
                }
                return venueSearch;
            })
            .sort((a, b) => sortTheList(a, b, 'mobileSortOrder', 'asc'));
    }
    return {
        type: SET_FILTERS,
        isBaseFiltersLoaded: true,
        venueSearchFilters: venueSearchFilters,
        sortFilters: data?.sortsets,
        venueSearchParams: venueSearchParams,
    };
}

export function setNewFilters(venueSearchFilters,log) {
    return {
        type: SET_PAGE_FILTERS,
        venueSearchFilters: venueSearchFilters,
    };
}

export function loadPageTags(pagetags) {
    return {
        type: SET_PAGETAGS,
        pagetags: pagetags,
    };
}

export function showVenueListLoader() {
    return {
        type: FETCHING_VENUES,
        isFetchingVenues: true,
    };
}

export function loadVenueList(data) {
    return {
        type: GET_VENUES,
        isFetchingVenues: false,
        list: data.venues,
        totalCount: data.totalCount,
        pageNum: data.pageNum,
        searchlink: data.searchlink,
        searchValidators: data.searchValidators,
    };
}

export function fetchVenueList(cityslug, keyword, query,code) {
    let url = `search/venues`;
  if (keyword && keyword !== '') {
        if(code){
            url = `${url}/${keyword}/${code}`
        }else{
            url = `${url}/${toString(cityslug)}/${keyword}/list`;
        }
    } else {
        url = `${url}/${toString(cityslug)}/venues/list`;
    }
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        dispatch(showVenueListLoader());
        const res = await callSearchAPI(url);
        if (res.status === 'Success') {
            if (!isEmpty(res.data.searchlink)) {
                dispatch(loadVenueList(res.data));
            } else {
                dispatch(setPageNotFound(true));
            }
        }
    };
}

export function showLoadingVenueSearchValidators(val) {
    return {
        type: UPDATING_VENUE_SEARCH_VALIDATORS,
        isUpdatingVenueSearchValidators: !!val,
    };
}

export function loadVenueSearchValidators(data) {
    return {
        type: UPDATE_VENUE_SEARCH_VALIDATORS,
        isUpdatingVenueSearchValidators: false,
        searchValidators: data.searchValidators,
        totalCount: data.totalCount,
    };
}

export function fetchVenueFiltersForList(cityslug, keyword, query) {
    let url = `search/venues`;
    if (keyword && keyword !== '') {
        url = `${url}/${toString(cityslug)}/${keyword}/filter-count`;
    } else {
        url = `${url}/${toString(cityslug)}/venues/filter-count`;
    }
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return (dispatch) => {
        dispatch(showLoadingVenueSearchValidators(true));
        return callApi(url, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadVenueSearchValidators(res.data));
            } else {
                dispatch(showLoadingVenueSearchValidators(false));
            }
        });
    };
}

export function fetchPackagesByVenueId(venueId) {
    return (dispatch) => {
        return callApi(`search/venue/${venueId}/packages`, 'get').then((res) => {
            dispatch();
        });
    };
}

// Venue Page

export function showVenuePageLoading() {
    return {
        type: FETCHING_VENUE,
        isLoadingVenuePage: true,
    };
}

export function loadVenuePage(data) {
    return {
        type: FETCH_VENUE_PAGE,
        venue: data.venue,
        mainPageVenue: data.mainPageVenue,
        packages: data.packages,
        images: data.images,
        menus: data.menus,
        venueQas: data.venueQas,
        venueFaqs: data.venueFaqs,
        comments: data.comments,
        totalCommentsCount: data.total,
        reviewPageNum: 1,
        isLoadingVenuePage: false,
        similarVenues: data.similarVenues,
        popularVenues: data.popularVenues,
        //  _________
        venueExpert: data.venueExpert,
        venueExpertReview: data.venueExpertReview,
    };
}

export function loadVenueAssetPage(data) {
    return {
        type: FETCH_ASSET_PAGE,
        venue: data.venue,
        assetPageVenue: data.assetPageVenue,
        images: data.images,
        realevents: data.realevents,
        isLoadingVenuePage: false,
        similarVenues: data.similarVenues,
        popularVenues: data.popularVenues,
        venueFaqs: data.venueFaqs,
    };
}

export function loadVenueReviewPage(data) {
    return {
        type: FETCH_REVIEW_PAGE,
        venue: data.venue,
        reviewPageVenue: data.reviewPageVenue,
        comments: data.comments,
        totalCommentsCount: data.total,
        reviewPageNum: 1,
        isLoadingVenuePage: false,
        similarVenues: data.similarVenues,
        popularVenues: data.popularVenues,
    };
}

export function loadVenuePackagePage(data) {
    return {
        type: FETCH_PACKAGE_PAGE,
        venue: data.venue,
        packagePageVenue: data.packagePageVenue,
        packages: data.packages,
        menus: data.menus,
        isLoadingVenuePage: false,
        similarVenues: data.similarVenues,
        popularVenues: data.popularVenues,
    };
}

export function setisSayaDate(val) {
    return {
        type: SET_SAYA_DATE_STATUS,
        isSayaDate: val,
    };
}

// c=0|c=1
// export function updateImageViewSeen(venueImageId) {
//   return (dispatch) => {
//     return callManagerApi(`api/v3/venueimages/${venueImageId}/update/image-seen`, 'post', { venueimage: { imageSeen: 1 } })
//       .then(res => {
//         if (res.status === 'Success') {
//           dispatch(true)
//         }
//       });
//   }
// }

export function cacheVenueUrl(cityslug, vm_id) {
    return (dispatch) => {
        return callApi(`venues/${cityslug}/${vm_id}/v2-pages`, 'GET').then((res) => res);
    };
}

export function decacheVenueUrl(cityslug, vm_id) {
    return (dispatch) => {
        return callApi(`venues/decache`, 'POST', {
            url: `${cityslug}/${vm_id}`,
        }).then((res) => res);
    };
}

export function fetchVenuePage(cityslug, url) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return venueCallApi(`venues/${toString(cityslug)}/${url}/v2-pages`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.mainPageVenue = res.data.venue;
                    res.data.venueQas = res.data.venueQas;
                    dispatch(loadVenuePage(res.data));
                }
            }
        });
    };
}

export function fetchPageTagsByUrl(url) {
    return (dispatch) => {
        return callApi(`search/venues/pagetags`, 'POST', {
            baseUrl: url,
        }).then((res) => {
            dispatch(loadPageTags(res.data.pagetags));
        });
    };
}

export function fetchVenueAssetsPage(cityslug, url) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return callApi(`venues/${toString(cityslug)}/${url}/assets`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.assetPageVenue = res.data.venue;
                    dispatch(loadVenueAssetPage(res.data));
                }
            }
        });
    };
}

export function fetchVenueReviewsPage(cityslug, url) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return callApi(`venues/${cityslug}/${url}/reviews`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.reviewPageVenue = res.data.venue;
                    dispatch(loadVenueReviewPage(res.data));
                }
            }
        });
    };
}

export function fetchVenuePackagesPage(cityslug, url) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return callApi(`venues/${cityslug}/${url}/packages-and-menus`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.packagePageVenue = res.data.venue;
                    dispatch(loadVenuePackagePage(res.data));
                }
            }
        });
    };
}

export function showVenueReviewsLoading() {
    return {
        type: FETCHING_REVIEW,
        isFetchingUserReviews: true,
        comments: [],
        totalCommentsCount: 0,
    };
}

export function loadBaseVenue(venue) {
    return {
        type: FETCH_VENUE,
        venue: venue,
    };
}

export function loadUserComment(data) {
    return {
        type: FETCH_USER_COMMENT,
        userComment: !isEmpty(data.comment) ? data.comment : {},
        userHasCommented: !isEmpty(data.comment),
    };
}

export function fetchUserComment(venueid, userid) {
    return (dispatch) => {
        return venueCallApi(`comments/venue/${venueid}/user/${userid}/list`, 'POST',{}, {
            version:'v2'
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadUserComment(res.data));
            }
        });
    };
}

export function checkIfIsSayaDate(date,event) {
    
    return (dispatch) => {
        return venueCallApi(`important-dates/is-important-date`, 'POST', {
            date: date
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(setisSayaDate(res.data));
                console.log(res.data); 
            }
        })
    };
}

export function showLoaderWhileAddingComment(val) {
    return {
        type: TOGGLE_NEW_COMMENT,
        isPostingUserComment: !!val,
    };
}

export function showLoaderWhileUpdatingVenueComment(val) {
    return {
        type: UPDATING_USER_COMMENT,
        isUpdatingUserComment: !!val,
    };
}

export function showLoaderWhileDeletingVenueComment(val) {
    return {
        type: DELETING_USER_COMMENT,
        isDeletingUserComment: !!val,
    };
}

export function addUserComment(venueid, userid, post) {
    
    return (dispatch) => {
        dispatch(showLoaderWhileAddingComment(true));
        return venueCallApi(`comments/${venueid}/new-comment`, 'POST', {
            comment: post,
        },{version:'v2'}).then((res) => {
            if (res.status === 'Success') {
                if (res.data.userCommentExists) {
                    userNotify(res.data.message, 'success');
                    dispatch(showLoaderWhileAddingComment(false));
                    
                } else {
                    // dispatch(setSuccessModalState(true));
                    userNotify('Your Review has been added', 'success');
                    dispatch(setLotteryTicketNumber(res.data))
                    dispatch(setSucessScreenState(true))
                    dispatch(showLoaderWhileAddingComment(false));
                    dispatch(fetchVenueComments(venueid, 1));
                    dispatch(fetchUserComment(venueid, userid));
                }
            } else {
                userNotify('Failed to add your Review. Please Try again.', 'error');
                dispatch(showLoaderWhileAddingComment(false));
            }
        });
    };
}

export function showFetchingCommentsLoader(val) {
    return {
        type: FETCHING_VENUE_COMMENTS,
        isFetchingComments: !!val,
    };
}

export function loadComments(commentsData, pageNum) {
    return {
        type: FETCH_VENUE_COMMENTS,
        isFetchingComments: false,
        comments: commentsData.comments,
        reviewPageNum: pageNum,
        // totalCommentsCount: commentsData.total,
        totalReviewCount: commentsData.total,
    };
}

export function fetchVenueComments(venueid, pageNum) {
    return (dispatch) => {
        dispatch(showFetchingCommentsLoader(true));
        return venueCallApi(`comments/${venueid}/list/review`, 'POST', {
            venueid: venueid,
            pageNum: pageNum,
        },{
            version:'v2'
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadComments(res.data, pageNum));
            }
        });
    };
}

export function fetchVenueCommentsCallback(venueid, pageNum, callback) {
    return (dispatch) => {
        dispatch(showFetchingCommentsLoader(true));
        return venueCallApi(`comments/${venueid}/list/review`, 'POST', {
            venueid: venueid,
            pageNum: pageNum,
        },{
            version:'v2'
        }).then((res) => {
            if (res.status === 'Success') {
                if (callback) {
                    callback(null, res.data.comments);
                }
            }
            dispatch(loadComments(res.data, pageNum));
            dispatch(showFetchingCommentsLoader(false));
        });
    };
}

export function updateVenueComment(id, venueid, userid, comment, cityslug, url) {
    return (dispatch) => {
        dispatch(showLoaderWhileUpdatingVenueComment(true));
        return venueCallApi(`comments/${id}/update-comment-user`, 'POST', {
            comment: comment,
        },{
            version:'v2'
        }).then((res) => {
            if (res.status === 'Success') {
                // dispatch(userNotify('Your Review has been updated', 'success'));
                dispatch(showLoaderWhileUpdatingVenueComment(false));
                dispatch(editUserComment(false));
                dispatch(fetchVenueComments(venueid, 1));
                dispatch(fetchUserComment(venueid, userid));
                dispatch(fetchVenuePage(cityslug, url));
            } else {
                dispatch(showLoaderWhileUpdatingVenueComment(false));
                dispatch(editUserComment(false));
            }
        });
    };
}

export function removeVenueComment(id, venueid, userid) {
    return (dispatch) => {
        dispatch(showLoaderWhileDeletingVenueComment(true));
        return venueCallApi(`comments/${id}/remove-comment`, 'POST', {},{
            version:'v2'
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(showLoaderWhileDeletingVenueComment(false));
                dispatch(fetchVenueComments(venueid, 1));
                dispatch(fetchUserComment(venueid, userid));
            } else {
                dispatch(showLoaderWhileDeletingVenueComment(false));
            }
        });
    };
}

export function editUserComment(val) {
    return (dispatch) => {
        dispatch({
            type: EDIT_USER_COMMENT,
            isEditingUserComment: val,
        });
    };
}

export function loadingReviewReport() {
    return {
        type: FETCHING_REPORTED_COMMENT,
        isLoadingReviewReport: true,
    };
}

export function loadReviewReport(data) {
    return {
        type: FETCH_REPORTED_COMMENT,
        isLoadingReviewReport: false,
        reportedComment: data.comment,
        isReportingComment: false,
    };
}

export function fetchReviewReportById(id) {
    return (dispatch) => {
        dispatch(loadingReviewReport());
        return venueCallApi(`comments/${id}`, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadReviewReport(res.data));
            } else {
                // dispatch(userNotify('Failed to register.Please try again.', 'error'));
            }
        });
    };
}

export function updatingReportedComment() {
    return {
        type: UPDATING_REPORTED_COMMENT,
        isReportingComment: true,
    };
}

export function updatingUserComment(val) {
    return {
        type: UPDATING_VENUE_USER_REVIEW,
        isSavingUserProfileComment: !!val,
    };
}

export function updateUserCommentInProfile(id, comment) {
    return {
        type: UPDATE_VENUE_USER_REVIEW,
        isSavingUserProfileComment: false,
        commentId: id,
        comment: comment,
    };
}

export function updateUserProfileComment(id, comment) {
    return (dispatch) => {
        dispatch(updatingUserComment(true));
        return callApi(`profile/${id}/review/update`, 'POST', {
            comment: comment,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(updateUserCommentInProfile(id, res.data.comment));
            } else {
                // dispatch(userNotify('Failed to register.Please try again.', 'error'));
                dispatch(updatingUserComment(false));
            }
        });
    };
}

export function updateUserComment(id, comment) {
    return (dispatch) => {
        dispatch(updatingReportedComment());
        return venueCallApi(`comments/${id}/update`, 'POST', {
            comment: comment,
        },{
            version : "v2"
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(fetchReviewReportById(id));
            } else {
                // dispatch(userNotify('Failed to register.Please try again.', 'error'));
            }
        });
    };
}

export function toggleNewEventPlanForm(val) {
    return {
        type: TOGGLE_NEW_EVENT_PLAN_MODAL,
        isNewEventFormVisible: !!val,
    };
}

export function eventMadeState(val) {
    return {
        type: EVENT_MADE_STATE,
        isEventMade: !!val,
    };
}

export function setSelectedVenue(venue) {
    return {
        type: SET_SELECTED_VENUE,
        selectedVenue: venue,
    };
}

export function fetchSeoLink(url) {
    return (dispatch) => {
        return callApi(`search/venues/seolink/page/${url}`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (res.data && res.data.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data && res.data.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    dispatch(setPageNotFound(true));
                }
            }
        });
    };
}

export function fetchKeywordRedirect(cityslug, keyword) {
    return (dispatch) => {
        return callApi(
            `search/venues/${toString(cityslug)}/keyword/${keyword}/redirect`,
            'get'
        ).then((res) => {
            if (res.status === 'Success') {
                let data = {};
                data.isPageRedirect = true;
                data.redirectStatus = 301;
                if (res.data.redirectUrl) {
                    data.redirectUrl = res.data.redirectUrl;
                } else {
                    data.redirectUrl = `/${lowerCase(cityslug)}/venues`;
                }
                dispatch(setPageRedirect(data));
            }
        });
    };
}

export function loadFormFilters(data) {
    return {
        type: SET_VENUE_FORM_FILTERS,
        venueFormFilters: data,
    };
}

export function fetchVenueFormFilters(cityslug) {
    return (dispatch) => {
        return callApi(`search/venues/${toString(cityslug)}/venue-form-filters`, 'get').then(
            (res) => {
                if (res.status === 'Success') {
                    dispatch(loadFormFilters(res.data));
                }
            }
        );
    };
}

export function showShortlistingVenueSearchPageLoader(venueid, value) {
    return {
        type: SHORTLISTING_VENUE_FROM_LIST,
        venueid: venueid,
        value: value,
    };
}

export function showShortlistingVenuePageLoader(value) {
    return {
        type: SHORTLISTING_VENUE_FOR_EVENT,
        isShortlistingVenue: value,
    };
}

export function loadingSearchLink(val) {
    return {
        type: FETCHING_SEARCHLINKS,
        isFetchingSearchLink: !!val,
    };
}

export function loadSearchLink(data) {
    return {
        type: LOAD_SEARCHLINK,
        isFetchingSearchLink: false,
        searchlink: {
            tags: data.tags,
            keyword: data.keyword,
            city: data.city,
            query: data.query,
        },
        list: data.venues,
        totalCount: data.totalCount,
        pageSize: data.pageSize,
        pageNum: data.pageNum,
        occasionFilters: data.occasions,
        venuetypeFilters: data.venuetypes,
        amenityFilters: data.facilities,
        minBudgetFilters: data.minBudgets,
        maxBudgetFilters: data.maxBudgets,
        minGuestFilters: data.minCapacity,
        maxGuestFilters: data.maxCapacity,
        locationFilters: data.locations,
        regionFilters: data.regions,
        packagetypeFilters: data.packagetypes,
        sortFilters: data.sortsets,
    };
}

export function fetchSearchLink(cityslug, url) {
    return (dispatch) => {
        dispatch(loadingSearchLink(true));
        return callApi(`search/venues/${toString(cityslug)}/searchlink/page/${url}`, 'get').then(
            (res) => {
                if (res.status === 'Success') {
                    if (isEmpty(res.data)) {
                        dispatch(setPageNotFound(true));
                    } else if (res.data && res.data.isRedirectLinkAvailable) {
                        let data = {};
                        data.isPageRedirect = true;
                        data.redirectStatus = 301;
                        data.redirectUrl = res.data.redirectToLink;
                        dispatch(setPageRedirect(data));
                    } else if (res.data && res.data.isDeleted) {
                        dispatch(setPageNotFound(true));
                    } else {
                        dispatch(loadSearchLink(res.data));
                    }
                }
            }
        );
    };
}

export function showLoaderSimilarVenues(val) {
    return {
        type: FETCHING_SIMILAR_VENUES,
        isFetchingSimilarVenues: val,
    };
}

export function loadSimilarVenues(data) {
    return {
        type: FETCH_SIMILAR_VENUES,
        isFetchingSimilarVenues: false,
        similarVenues: data.similarVenues,
    };
}

export function fetchSimilarVenues(list) {
    return (dispatch) => {
        dispatch(showLoaderSimilarVenues(true));
        return callApi(`venues/similar-venues`, 'post', {
            list: list,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadSimilarVenues(res.data));
            } else {
                dispatch(showLoaderSimilarVenues(false));
            }
        });
    };
}

export function showLoaderCompareVenues(val) {
    return {
        type: FETCHING_COMPARE_VENUES,
        isFetchingCompareVenues: val,
    };
}

export function loadCompareVenues(data) {
    return {
        type: FETCH_SIMILAR_VENUES,
        isFetchingCompareVenues: false,
        compareVenues: data.compareVenues,
    };
}

export function fetchCompareVenues(list) {
    return (dispatch) => {
        dispatch(showLoaderCompareVenues(true));
        return callApi(`venues/compare-venues`, 'post', {
            list: list,
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(loadCompareVenues(res.data));
            } else {
                dispatch(showLoaderCompareVenues(false));
            }
        });
    };
}

export function showVenueDataLoading(val) {
    return {
        type: FETCHING_VENUE_DATA_FOR_COMPARE_PAGE,
        isLoadingVenueData: val,
    };
}

export function loadVenueData(data) {
    return {
        type: FETCH_VENUE_DATA_FOR_COMPARE_PAGE,
        compareVenue: data,
    };
}

export function fetchVenueData(url, colName) {
    return async (dispatch) => {
        dispatch(showVenueDataLoading(true));
        const res = await callApi(`venues/${url}`, 'get');
        if (res.status === 'Success') {
            if (isEmpty(res.data.venue)) {
                dispatch(setPageNotFound(true));
                dispatch(showVenueDataLoading(false));
            } else {
                let compareVenue = {};
                compareVenue[colName] = res.data.venue;
                dispatch(loadVenueData(compareVenue));
                dispatch(showVenueDataLoading(false));
            }
        }
    };
}

export function clearVenueData() {
    return {
        type: CLEAR_COMPARE_VENUE_DATA,
    };
}

export function setQnaPageNum(qnaPageNum) {
    return {
        type: SET_QNA_PAGE_NUM,
        qnaPageNum: qnaPageNum,
    };
}

export function loadQnAPage(data) {
    return {
        type: FETCH_QNA_PAGE,
        venue: data.venue,
        images: data.images,
        qnaList: data.venueQaList,
        qnaCount: data.venueQaListCount,
        venueFaqs: data.venueFaqs,
        similarVenues: data.similarVenues,
        customerReviews: data.customerReviews,
        venueExpert: data.venueExpert,
        venueExpertReview: data.venueExpertReview,
        isLoadingVenuePage: false,
    };
}

export function fetchVenueQna(venueid, pageNum) {
    return async (dispatch) => {
        dispatch(showFetchingQnasLoader(true));
        const res = await callApi(`venueqa/venue/${venueid}/list`, 'POST', {
            venueid: venueid,
            pageNum: pageNum,
        });
        if (res.status === 'Success') {
            dispatch(loadMoreQna(res.data, pageNum));
        } else {
            dispatch(showFetchingQnasLoader(false));
        }
    };
}

export function fetchVenueQnAPage(cityslug, url, venueid, userid) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return venueCallApi(`venues/${toString(cityslug)}/${url}/v2-pages`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.qaPageVenue = res.data.venue;
                    dispatch(loadQnAPage(res.data));
                    // dispatch(loadUserQuestion(res.data));
                    // dispatch(fetchUserAskedQuestion(venueid, userid))
                }
            }
        });
    };
}

export function fetchSublinkPage(quesurl) {
    return (dispatch) => {
        return newcallApi(`venues/question/${quesurl}`, 'GET').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venueQa) || isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data && res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                    // } else if ((res.data.venueQa && res.data.venueQa.is_deleted)||(res.data && res.data.venue && res.data.venue.isDeleted)) {
                    //   dispatch(setPageNotFound(true));
                } else {
                    dispatch(setPageNotFound(false));
                    dispatch(loadSublinkPage(res.data));
                    res.data.mainPageVenue = res.data.venue;
                    dispatch(loadVenuePage(res.data));
                }
            }
        });
    };
}

export function loadSublinkPage(data) {
    return {
        type: LOAD_SUBLINK_PAGE,
        sublinkPage: data,
    };
}

export function loadUserQuestion(data) {
    return {
        type: FETCH_USER_QUESTION,
        getUserAskedQuestionList: !isEmpty(data.venueqas) ? data.venueqas : [],
        getUserAskedQuestionCount: data.venueqaCount,
    };
}

export function fetchUserAskedQuestion(venueid, userid) {
    return (dispatch) => {
        return callApi(`venueqa/venue/${venueid}/user/${userid}/list`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadUserQuestion(res.data.venueqa));
            }
        });
    };
}

export function addAnswerModalVisibleState(val, modalInfo) {
    return {
        type: ADD_ANSWER_MODAL_STATE,
        addAnswerModalVisibilityState: val,
        answerModalContextState: modalInfo,
    };
}

export function setAddAnswerModalVisibleState(val, modalInfo) {
    return (dispatch) => {
        dispatch(addAnswerModalVisibleState(val, modalInfo));
    };
}

export function showFetchingQnasLoader(val) {
    return {
        type: FETCHING_MORE_QNA,
        isFetchingMoreQna: !!val,
    };
}

export function loadMoreQna(data, pageNum) {
    return {
        type: FETCH_MORE_QNA,
        isFetchingMoreQna: false,
        moreQnaList: data.venueqas.venueQaList,
        qnaPageNum: pageNum,
    };
}

export function fetchMoreVenueQna(venueid, pageNum, callback) {
    return (dispatch) => {
        dispatch(showFetchingQnasLoader(true));
        return callApi(`venueqa/venue/${venueid}/list`, 'POST', {
            venueid: venueid,
            pageNum: pageNum,
        }).then((res) => {
            if (res.status === 'Success') {
                if (callback) {
                    callback(null, res.data.venueqas.venueQaList);
                }
                dispatch(loadMoreQna(res.data, pageNum));
            } else {
                dispatch(showFetchingQnasLoader(false));
            }
        });
    };
}

export function editUserAnswer(
    venueid,
    questionid,
    userid,
    answerid,
    answerValue,
    cityslug,
    url,
    questionurl
) {
    return (dispatch) => {
        return callApi(
            `venueqa/venue/${venueid}/question/${questionid}/user/${userid}/answer/${answerid}/update`,
            'POST',
            {
                answer: answerValue,
            }
        ).then((res) => {
            if (res.status === 'Success') {
                dispatch(fetchVenueQnAPage(cityslug, url));
                dispatch(fetchUserAskedQuestion(venueid, userid));
                if (questionurl !== null && questionurl !== undefined) {
                    dispatch(fetchSublinkPage(questionurl));
                }
            }
        });
    };
}

export function deleteUserAnswer(venueid, input, cityslug, url, questionurl) {
    const { answerid, questionid, userid } = input;
    return (dispatch) => {
        return callApi(
            `venueqa/venue/${venueid}/question/${questionid}/user/${userid}/answer/${answerid}/delete`,
            'POST',
            {}
        ).then((res) => {
            if (res.status === 'Success') {
                dispatch(fetchUserAskedQuestion(venueid, userid));
                dispatch(fetchVenueQnAPage(cityslug, url));
                dispatch(fetchVenuePage(cityslug, url));
                if (questionurl !== null && questionurl !== undefined) {
                    dispatch(fetchSublinkPage(questionurl));
                }
            }
        });
    };
}

export function updateQnaHomePage(val) {
    return {
        type: UPDATE_QNA_HOMEPAGE,
        val: val,
    };
}

export function callAddNewAnswer(input) {
    const {
        venueid,
        userid,
        questionid,
        newAnsValue,
        username,
        cityslug,
        url,
        questionurl,
    } = input;
    return (dispatch) => {
        return callApi(`venueqa/venue/${venueid}/${questionid}/add`, 'POST', {
            answer: {
                answer_text: newAnsValue,
                user_id: userid,
                user_name: username,
                user_type: 'user',
                filled_at: new Date(),
                wordCount: newAnsValue.split(' ').length,
            },
        }).then((res) => {
            if (res.status === 'Success') {
                dispatch(fetchVenueQnAPage(cityslug, url));
                dispatch(fetchUserAskedQuestion(venueid, userid));
                dispatch(updateQnaHomePage(true));
                if (questionurl !== null && questionurl !== undefined) {
                    dispatch(fetchSublinkPage(questionurl));
                }
            }
        });
    };
}

export function setQnASuggestionList(data) {
    return {
        type: GET_QNA_SUGGESTION_LIST,
        getQnASuggestionList: data,
    };
}

export function fetchQnASuggestionList(venueId, qtext) {
    return (dispatch) => {
        return callApi(`venueqa/venue/${venueId}?qtext=${qtext}`, 'GET').then((res) => {
            if (res.status === 'Success') {
                dispatch(
                    setQnASuggestionList(res.data && res.data.venueqas ? res.data.venueqas : [])
                );
            }
        });
    };
}

export function setIsUserQuestionPosted(value) {
    return {
        type: IS_USER_QUESTION_POSTED,
        isUserQuestionPosted: value,
    };
}

export function addUserQuestion(venueQuestion, venueid, userid, cityslug, url) {
    return (dispatch) => {
        dispatch(setIsUserQuestionPosted(false));
        return callApi(`venueqa/venue/${venueQuestion.venueId}/new`, 'POST', venueQuestion).then(
            (res) => {
                if (res.status === 'Success') {
                    // dispatch(setPostUserQuestion(res.data))
                    dispatch(setIsUserQuestionPosted(true));
                    dispatch(setSuccessModalState(true));
                    dispatch(fetchVenueQnAPage(cityslug, url));
                    dispatch(fetchUserAskedQuestion(venueid, userid));
                }
            }
        );
    };
}

export function setSuccessModalState(val) {
    return {
        type: SET_SUCCESS_MODAL_STATE,
        isSuccessModalVisible: val,
    };
}

export function setSucessScreenState(val) {
    return {
        type: SET_SUCCESS_SCREEN,
        isShowSuccessScreen: val
    }
}

export function setLotteryTicketNumber(data) {
    return {
        type: GET_REVIEW_TICKET_DATA,
        reviewticketdata: data
    }
}




export function questionAlreadyExistModal(val) {
    return {
        type: QUESTION_ALREADY_EXIST,
        questionAlreadyExistModal: val,
    };
}

export function editUserQuestion(venueid, quesid, userid, questionValue, cityslug, url) {
    return (dispatch) => {
        return callApi(
            `venueqa/venue/${venueid}/question/${quesid}/user/${userid}/update`,
            'POST',
            {
                question: questionValue,
            }
        ).then((res) => {
            if (res.status === 'Success') {
                if (res.data.venueqa.isDuplicate) {
                    dispatch(questionAlreadyExistModal(true));
                } else {
                    dispatch(fetchUserAskedQuestion(venueid, userid));
                    dispatch(fetchVenueQnAPage(cityslug, url));
                }
            }
        });
    };
}

export function deleteUserQuestion(venueid, quesid, userid, cityslug, url) {
    return (dispatch) => {
        dispatch(showLoaderWhileDeletingUserQuestion(true));
        return callApi(`venueqa/venue/question/${quesid}/user/${userid}/delete`, 'POST', {}).then(
            (res) => {
                if (res.status === 'Success') {
                    dispatch(showLoaderWhileDeletingUserQuestion(true));
                    dispatch(
                        setDeleteUserQuestionStatus(
                            res.data.venueqa.is_deleted ? res.data.venueqa.is_deleted : ''
                        )
                    );
                    dispatch(fetchUserAskedQuestion(venueid, userid));
                    dispatch(fetchVenueQnAPage(cityslug, url));
                } else {
                    showLoaderWhileDeletingUserQuestion(true);
                }
            }
        );
    };
}

export function showLoaderWhileDeletingUserQuestion(val) {
    return {
        type: DELETING_USER_QUESTION,
        isDeletingUserQuestion: val,
    };
}

export function setDeleteUserQuestionStatus(val) {
    return {
        type: DELETE_USER_QUESTION,
        isUserQuestionDeleted: val,
        isUserDeleteQuestionProcessed: true,
    };
}

export function processingDeleteQuestion(val) {
    return {
        type: PROCESSING_DELETE_QUESTION,
        payload: val,
    };
}

export function isUploadingMedia(val) {
    return {
        type: IS_UPLOADING_MEDIA,
        payload: val,
    };
}

export function mediaUploaded(data) {}

export function uploadMedia(file, fileName, filePath, cityslug, url) {
    return async (dispatch) => {
        dispatch(isUploadingMedia(true));
        let data = new FormData();
        data.append('file', file);

        const res = await uploadFile(`v1/assets/upload?fileName=${filePath}`, 'post', data);
        if (res.status === 'Success') {
            dispatch(isUploadingMedia(false));
            dispatch(fetchVenuePage(cityslug, url));
        } else {
            console.log('Error in uploading media');
            userNotify('Error in uploading media', 'error');
        }
    };
}

export function openGalleryForVenueImagesGallery(val, venue) {
    return {
        type: IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        venue: venue,
        isFetchingVenueAssets: val,
    };
}

export function closeGalleryForVenueImagesGallery(val) {
    return {
        type: IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        isFetchingVenueAssets: val,
    };
}

export function clickedVenueOnSearchPage(val) {
    return {
        type: CLICKED_VENUE_SEARCH_PAGE,
        payload: val,
    };
}

export function loadVenueSearchPageVenueAssets(venue_id, images, assets) {
    return {
        type: FETCH_VENUE_SEARCH_PAGE_ALL_ASSET,
        venue_id: venue_id,
        images,
        assets,
    };
}

export function fetchVenueSearchPageAllAsset(venue) {
    return async (dispatch, getState) => {
        let clickedVenueAssets = getState()?.venue?.clickedVenueAssets;
        dispatch(openGalleryForVenueImagesGallery(true, venue));
        if (
            !clickedVenueAssets[venue?._id]?.images ||
            !(clickedVenueAssets[venue?._id]?.images?.length > 0)
        ) {
            const res = await venueCallApi(`venueassets/venue/${venue?._id}/assets`, 'post', {
                city_slug: venue?.city_slug,
            });
            if (res.status === 'Success') {
                dispatch(
                    loadVenueSearchPageVenueAssets(
                        venue._id,
                        res.data.venueImages,
                        res.data.venueAssets
                    )
                );
            } else {
                userNotify('Error in fetching media', 'error');
            }
        }
    };
}


export function setVenueTourModalVisibility(val){
    return {
        type: SET_VENUE_TOUR_MODAL_VISIBILTIY,
        isVenueTourModalVisible: val
    }
}